// Author panyurou
// Date 2023-02-23 16:02:35

import * as model from "@/model/sithMes/customer/SithMesCustomerModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesCustomer(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_CUSTOMER_URL,
    })
    .buildStore()
